<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" [colCount]="3" (onEditorEnterKey)="getData()">
                <dxi-item dataField="startDate" editorType="dxDateBox" [label]="{ text: 'Created From' }"></dxi-item>
                <dxi-item dataField="endDate" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                <dxi-item>
                    <button type="button" (click)="getData()" class="btn btn-primary">Search</button>
                </dxi-item>
            </dx-form>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="orderLineDetails">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="orderLineDetails"
            [columnAutoWidth]="false"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="partNumber" width="150"></dxi-column>
            <dxi-column dataField="category" width="100"></dxi-column>
            <dxi-column dataField="description" width="200"></dxi-column>
            <dxi-column dataField="month" width="75"></dxi-column>
            <dxi-column dataField="year" width="75"></dxi-column>
            <dxi-column dataField="createDate" dataType="date" width="150"></dxi-column>
            <!-- <dxi-column dataField="displayName" caption="Sales Rep" width="75"></dxi-column> -->
            <dxi-column dataField="quantity" width="100"></dxi-column>
            <dxi-column dataField="price" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="companyName" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="invoiceNumber" caption="Sales Order Number" width="150"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-summary>
                <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-group-item column="total" summaryType="sum" displayFormat="Total: {0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-group-item>
                <dxi-group-item column="quantity" summaryType="count"> </dxi-group-item>
            </dxo-summary>
            <dxo-grouping [autoExpandAll]="false"> </dxo-grouping>

            <dxo-group-panel [visible]="true"></dxo-group-panel>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="report-sales-by-part-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="orderLineDetails" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
